import { render, staticRenderFns } from "./null.vue?vue&type=template&id=10b9ad1b&"
import script from "./null.vue?vue&type=script&lang=js&"
export * from "./null.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports